import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const editLinkSlice = createSlice({
  name: "editLink",
  initialState,
  reducers: {
    editLinkRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    editLinkRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    editLinkRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  editLinkRequested,
  editLinkRequestFailed,
  editLinkRequestSucceeded,
} = editLinkSlice.actions;

export default editLinkSlice.reducer;
